var w = Object.defineProperty;
var x = (n, t, e) => t in n ? w(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var o = (n, t, e) => (x(n, typeof t != "symbol" ? t + "" : t, e), e);
import { EditorView as V } from "@codemirror/view";
const E = {
  /**
   * URL where the file will be send
   */
  uploadUrl: "/upload",
  /**
   * Which method will be used to send the file to the upload URL
   */
  uploadMethod: "POST",
  /**
   * Name in which the file will be placed
   */
  uploadFieldName: "file",
  /**
   * Extension which will be used when a file extension could not
   * be detected
   */
  defaultExtension: "png",
  /**
   * JSON field which refers to the uploaded file URL
   */
  responseUrlKey: "url",
  /**
   * Allowed MIME types
   */
  allowedTypes: [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/gif"
  ],
  /**
   * Text which will be inserted when dropping or pasting a file.
   * Acts as a placeholder which will be replaced when the file is done with uploading
   */
  progressText: "![Uploading file...]()",
  /**
   * When a file has successfully been uploaded the progressText
   * will be replaced by the urlText, the {url} tag will be replaced response url
   */
  urlText: "![{alt}]({url})",
  /**
   * Text which will be used when uploading has failed
   */
  errorText: "Error uploading file",
  /**
   * Extra parameters which will be send when uploading a file
   */
  extraParams: {},
  /**
   * Extra headers which will be send when uploading a file
   */
  extraHeaders: {},
  /**
   * Before the file is send
   */
  beforeFileUpload() {
    return !0;
  },
  /**
   * Triggers when a file is dropped or pasted
   */
  onFileReceived() {
    return !0;
  },
  /**
   * Custom upload handler
   *
   * @return {Boolean} when false is returned it will prevent default upload behavior
   */
  onFileUploadSucceed() {
    return !0;
  },
  /**
   * Custom error handler. Runs after removing the placeholder text and before the alert().
   * Return false from this function to prevent the alert dialog.
   *
   * @return {Boolean} when false is returned it will prevent default error behavior
   */
  onFileUploadError() {
    return !0;
  },
  /**
   * When a file has successfully been uploaded
   */
  onFileUploaded() {
  }
};
async function D({
  url: n,
  ...t
}) {
  try {
    const e = await fetch(n, t);
    if (!e.ok)
      throw new Error(e.statusText);
    return {
      ok: !0,
      value: await e.json()
    };
  } catch (e) {
    return {
      ok: !1,
      value: e
    };
  }
}
function T(n) {
  return typeof n == "function";
}
function A(n, t = "", e = "") {
  const s = t.split(".");
  let i = n;
  for (const r of s)
    if (i && typeof i == "object" && r in i)
      i = i[r];
    else
      return e;
  return i !== void 0 ? i : e;
}
class v {
  constructor(t, e) {
    o(this, "options", E);
    o(this, "editor");
    o(this, "filename", "");
    o(this, "lastValue", "");
    this.editor = t, this.options = { ...E, ...e };
  }
  /** Uploads file */
  async uploadFile(t) {
    const {
      defaultExtension: e,
      remoteFilename: s,
      uploadFieldName: i,
      extraParams: r,
      extraHeaders: l,
      uploadUrl: c,
      uploadMethod: p,
      beforeFileUpload: d
    } = this.options, a = new FormData();
    let f = e;
    if (t.name) {
      const [u] = t.name.match(/\.(.+)$/) || [];
      u && (f = u);
    }
    const g = (s == null ? void 0 : s(t)) || `image-${Date.now()}.${f}`;
    if (this.filename = g, a.append(i, t, g), Object.keys(r).forEach((u) => {
      a.append(u, r[u]);
    }), !(d != null && d(a)))
      return;
    const { ok: F, value: m } = await D({
      url: c,
      method: p,
      body: a,
      headers: l
    });
    if (!F) {
      this.onFileUploadError(m);
      return;
    }
    this.onFileUploadSucceed(m);
  }
  /**
   * Returns if the given file is allowed to handle
   */
  isFileAllowed(t) {
    const { allowedTypes: e } = this.options;
    return e.includes("*") || e.includes(t.type);
  }
  /**
   * Handles upload response
   */
  onFileUploadSucceed(t) {
    var d, a;
    const { onFileUploadSucceed: e, urlText: s, responseUrlKey: i } = this.options;
    if (!(e != null && e(t)) || !this.lastValue)
      return;
    const r = A(t, i) || "unknown URL";
    if (!r)
      return;
    const l = /!\[({[^}]+})]\(([^)]+)\)/, c = T(s) ? s(r, t) : s.replace(s.match(l)[1], this.filename).replace(s.match(l)[2], r), p = this.editor.getValue().replace(this.lastValue, c);
    this.editor.setValue(p), (a = (d = this.options).onFileUploaded) == null || a.call(d, r);
  }
  /**
   * Called when a file has failed to upload
   */
  onFileUploadError(t) {
    var s, i;
    if (!((i = (s = this.options).onFileUploadError) != null && i.call(s, t)) || !this.lastValue)
      return;
    const e = this.editor.getValue().replace(this.lastValue, this.options.errorText);
    this.editor.setValue(e);
  }
  /**
   * Called when a file has been inserted, either by drop or paste
   */
  onFileInserted(t) {
    var e, s;
    (s = (e = this.options).onFileReceived) != null && s.call(e, t) && (this.lastValue = this.options.progressText, this.editor.insertValue(this.lastValue));
  }
  handleFiles(t) {
    Array.from(t).forEach((e) => {
      this.isFileAllowed(e) && (this.onFileInserted(e), this.uploadFile(e));
    });
  }
  /**
   * Called when a paste event occurred
   */
  onPaste(t) {
    var e;
    (e = t.clipboardData) != null && e.files.length && this.handleFiles(t.clipboardData.files);
  }
  /**
   * Called when a drop event occurred
   */
  onDrop(t) {
    var e;
    (e = t.dataTransfer) != null && e.files.length && this.handleFiles(t.dataTransfer.files);
  }
}
function U(n, t) {
  const e = n.scrollTop, s = n.selectionStart || 0, { value: i } = n, r = i.slice(0, s), l = i.slice(s, i.length);
  n.value = r + t + l;
  const c = s + t.length;
  n.selectionStart = c, n.selectionEnd = c, n.scrollTop = e, n.focus();
}
class b {
  constructor(t) {
    o(this, "instance");
    this.instance = t;
  }
  getValue() {
    return this.instance.value;
  }
  insertValue(t) {
    U(this.instance, t), this.dispatchInputEvent();
  }
  setValue(t) {
    this.instance.value = t, this.dispatchInputEvent();
  }
  dispatchInputEvent() {
    this.instance.dispatchEvent(new InputEvent("input", {
      bubbles: !0,
      cancelable: !0
    }));
  }
}
class y extends v {
  constructor(t, e = {}) {
    super(new b(t), e);
  }
  bind() {
    this.editor.instance.addEventListener(
      "paste",
      (t) => {
        this.onPaste(t);
      }
    ), this.editor.instance.addEventListener(
      "drop",
      (t) => {
        t.preventDefault(), this.onDrop(t);
      }
    ), this.editor.instance.addEventListener(
      "dragover",
      (t) => {
        t.preventDefault();
      }
    );
  }
}
function L(...n) {
  return new y(...n).bind();
}
class P {
  constructor(t) {
    o(this, "instance");
    this.instance = t;
  }
  getValue() {
    return this.instance.state.doc.toString();
  }
  insertValue(t) {
    this.instance.dispatch(this.instance.state.replaceSelection(t));
  }
  setValue(t) {
    const e = this.instance.state.selection.main.head;
    this.instance.dispatch({
      changes: {
        from: 0,
        to: this.instance.state.doc.length,
        insert: t
      }
    }), this.instance.dispatch({ selection: { anchor: e } });
  }
}
class h extends v {
  constructor(t, e = {}) {
    super(new P(t), e);
  }
  bind() {
    this.editor.instance.dom.addEventListener(
      "paste",
      (t) => {
        this.onPaste(t);
      }
    ), this.editor.instance.dom.addEventListener(
      "drop",
      (t) => {
        t.preventDefault(), this.onDrop(t);
      }
    ), this.editor.instance.dom.addEventListener(
      "dragover",
      (t) => {
        t.preventDefault();
      }
    );
  }
}
function S(...n) {
  return new h(...n).bind();
}
function M(n = {}) {
  return V.domEventHandlers({
    paste: (t, e) => {
      new h(e, n).onPaste(t);
    },
    drop: (t, e) => {
      t.stopPropagation(), t.preventDefault(), new h(e, n).onDrop(t);
    },
    dragenter: (t) => {
      t.stopPropagation(), t.preventDefault();
    },
    dragover: (t) => {
      t.stopPropagation(), t.preventDefault();
    }
  });
}
export {
  h as CodeMirrorInlineAttachmentAdapter,
  E as DEFAULT_OPTIONS,
  v as InlineAttachment,
  y as InputInlineAttachmentAdapter,
  L as attach,
  S as attachCodeMirror,
  M as inlineAttachmentExtension
};
